import { Container, Typography } from "@mui/material";

import TopSection from "../../compontents/common/TopSection";
import MainSection from "../../compontents/common/MainSection";
import ProjectGrid from "../../compontents/project/ProjectGrid";
import StoryGrid from "../../compontents/story/StoryGrid";
import AboutScroller from "../../compontents/about/AboutScroller";

export default function LandingPage() {
    return (
        <>
            <TopSection 
                title={"Rooted in Community, Elevated by Storytelling."}
                desc=""
                contentTranslateY={-10}
                descBottom={16}
                maxTitleFont="120px"
                carousel={true}
            />
            
            <MainSection paddingAmount="0px 20px" direction="flex-start">
                <Container sx={{padding: '20px 0 40px', paddingX: { xs: 2, sm: 5, md: 0 }}}>
                    <Typography sx={{ fontSize: '16px', color: 'white', mb: 1, padding: '0px 0px 16px', textAlign: 'left' }}>
                        FEATURED SERVICES
                    </Typography>
            
                    <ProjectGrid 
                        shownTitles={
                            ["Audio Engineering", "Video Production", "Experimental", "Podcast Subscription Plans"]
                        } 
                    />
                </Container>

                <Container sx={{padding: '20px 0 40px', paddingX: { xs: 2, sm: 5, md: 0 }}}>
                    <AboutScroller 
                        specificDataFrom="landing"
                        animationOn={false}  
                    />
                </Container>

                <Container sx={{padding: '20px 0 40px', paddingX: { xs: 2, sm: 5, md: 0 }}}>
                    <Typography sx={{ fontSize: '16px', color: 'white', mb: 1, padding: '0px 0px 16px', textAlign: 'left' }}>
                        STORIES
                    </Typography>
            
                    <StoryGrid 
                        numberOfStories="7" 
                        landingStyle={true}
                    />
                </Container>
            </MainSection>
        </>
    );
}